module.exports = __webpack_public_path__ + "media/images/scansoles-logo-096a7ced938887718d38db86491eb558.png";